<template>

    <div class="fingerprint-reading-container">
        <v-btn color="grey lighten-3" class="input-button" block depressed @click="$emit('click')">
            {{ complete ? (successTitle || title ) : title }}
            <v-icon :color="complete ? 'green' : ''">
                mdi-fingerprint
            </v-icon>
        </v-btn>

        <div v-if="errorMessages && errorMessages.length">
            <p class="error--text px-0 py-0 mx-0 my-0" v-for="(error, index) in errorMessages" :key="index">{{ error }}</p>
        </div>

    </div>



</template>
<script>
export default {
    props: [ 'title', 'errorMessages', 'complete', 'successTitle'],
    data() {
        return {
            // complete: false
        }
    },
}
</script>

<style lang="scss">

.input-button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .v-btn__content {
        color: rgba(0, 0, 0, 0.6);
    }
}

</style>